/* audioplayer.js: Implement a global audio player */
import $ from 'jquery';

var playlist, player, playingID;
var isPlaying = false;

export function init() {
	$.when(getPlaylist()).then(
		function(status) {
			preparePlayback();
			enablePlayer();
		},
		function(status) {
			console.log("Fetching playlist failed, not enabling player");
		});

	$(function() {
		player = $('.player');

		// buttons
		player.find('.player-controls-playpause').click(function() {
			playPause();
		});
		player.find('.player-controls-previous').click(function() {
			previous();
		});
		player.find('.player-controls-next').click(function() {
			next();
		});

		// update play head
		player.find('.player-element').on('timeupdate', function() {
			player.find('.player-controls-seekbar').attr("value", this.currentTime / this.duration);
		}).on('loadeddata', function() {
			if(isPlaying) {
				hideLoading();
			}
		});

		player.find('.player-element').on('ended', function() {
			preparePlayback(playingID + 1);
		});

		// bind clicking on tracks within a track list
		$('.content').on('click', '.releases-release-tracklist-track', function(event) {
			var target = $(event.target);
			if(!target.is('.releases-release-tracklist-track')) {
				target = target.parents('.releases-release-tracklist-track');
			}
			var trackId = target.data('trackId');
			preparePlayback(findID(trackId), {autoplay: true});
		});
	});
}

function getPlaylist() {
	var playlistDone = $.Deferred();
	$.getJSON('/playlist').done(function(data) {
		playlist = data.playlist;
		playlistDone.resolve();
	}).fail(function(data) {
		playlistDone.reject();
	});

	return playlistDone.promise();
}

function enablePlayer() {
	player.show();
}

function preparePlayback(id, options) {
	if(typeof(id) === 'undefined') {
		id = 0;
	}

	var song = playlist[id];
	playingID = id;

	player.find('.player-controls-albumart-image').attr('src', song.cover).attr('alt', song.title);
	player.find('.player-controls-title').text(song.title);
	player.find('.player-controls-link').attr('href', '/musik/'+song.release_title_safe);
	player.find('.player-element').attr('src', '/releases/' + song.path);

	// after we skip a song, the player stops playing. In that case,
	//  make it start again!
	if(isPlaying) {
		play();
	}

	if(typeof(options) !== 'undefined' && options.autoplay) {
		play();
	}
}

function playPause() {
	if(isPlaying) {
		pause();
	}
	else {
		play();
	}
}

function play() {
	showLoading();
	var element = player.find('.player-element')[0];
	var stateImage = player.find('.player-controls-playstate');
	element.play();
	stateImage.attr('src', '/images/player/pause.svg');
	isPlaying = true;
}
function pause() {
	var element = player.find('.player-element')[0];
	var stateImage = player.find('.player-controls-playstate');
	element.pause();
	stateImage.attr('src', '/images/player/play.svg');
	isPlaying = false;
}

function next() {
	playingID++;
	if(playingID >= playlist.length) {
		playingID = 0;
	}
	preparePlayback(playingID, {autoplay: true});
}

function previous() {
	playingID--;
	if(playingID < 0) {
		playingID = playlist.length - 1;
	}
	preparePlayback(playingID, {autoplay: true});
}

function findID(trackId) {
	var i;
	for(i = 0; i < playlist.length; i++) {
		if(playlist[i].track_id === trackId) {
			return i;
		}
	}
	return 0;
}

function showLoading() {
	player.find('.player-loading').show();
}
function hideLoading() {
	player.find('.player-loading').hide();
}

function volumeUp() {

}

function volumeDown() {

};




//////////////////
// WEBPACK FOOTER
// ./public/js/~/audioplayer.js
// module id = 1
// module chunks = 0